<template>
  <v-card width="100%">
    <management-nav />
    <v-card-title>
      Anatomia w praktyce - lekcje
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Szukaj" single-line hide-details
        ><font-awesome-icon
          icon="search"
          slot="prepend-inner"
          class="mr-1 mt-1"
      /></v-text-field>
    </v-card-title>
    <v-data-table
      :loading="!items"
      loading-text="Trwa pobieranie danych..."
      :headers="headers"
      :items="items"
      :search="search"
    >
      <template v-slot:no-data>
        <v-alert :value="items && items.length === 0"> Brak lekcji </v-alert>
      </template>
      <template v-slot:[`item.active`]="{ item }">
        <p style="text-align: center">{{ item.active ? "Tak" : "Nie" }}</p>
        <v-btn
          style="font-size: 12px; width: 100px"
          @click="markStatusAsActiveOrInactive(item)"
        >
          {{ item.active ? "Dezaktywuj" : "Aktywuj" }}
        </v-btn>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="green"
              @click="editLesson(item)"
              v-bind="attrs"
              v-on="on"
              v-on:click="isModalVisible = true"
            >
              <font-awesome-icon icon="edit" />
            </v-btn>
          </template>
          <span>Edytuj</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              @click="(isDeleteModalVisible = true), (packageData = item)"
              v-bind="attrs"
              v-on="on"
            >
              <font-awesome-icon icon="times" />
            </v-btn>
          </template>
          <span>Usuń</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="orange"
              @click="copyWorkshop(item)"
              v-bind="attrs"
              v-on="on"
              v-on:click="isModalVisible = true"
            >
              <font-awesome-icon icon="copy" />
            </v-btn>
          </template>
          <span>Kopiuj</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.description`]="{ item }">
        <template>
          <p
            style="max-height: 200px; min-width: 300px; overflow: hidden"
            :id="item.id"
            v-html="htmlToFormattedText(item.description)"
          />
        </template>
      </template>
      <template v-slot:[`item.photo`]="{ item }">
        <template>
          <img
            class="item-image"
            :id="`image_${item.id}`"
            @click="editLesson(item)"
            v-on:click="isModalVisible = true"
            alt=""
            loading="lazy"
          />
        </template>
      </template>
    </v-data-table>
    <add-theory-practice-workshop-lesson-modal
      :isVisible="isModalVisible"
      :workshopItemData="lessonData"
      @closeModal="closeModal()"
      @updated="refreshWorkshops()"
    />
    <before-delete-modal
      :isVisible="isDeleteModalVisible"
      @closeModal="closeDeleteModal()"
      @confirmDeletion="confirmDelete(packageData.id)"
    />
    <v-btn
      fab
      dark
      large
      color="green"
      fixed
      left
      bottom
      v-on:click="isModalVisible = true"
    >
      <font-awesome-icon icon="plus" />
    </v-btn>
  </v-card>
</template>

<script>
import ManagementNav from "../components/ManagementNav.vue";
import { SERVER_URL } from "../axios";
import BeforeDeleteModal from "../components/modals/BeforeDeleteModal.vue";
import AddTheoryPracticeWorkshopLessonModal from "../components/modals/AddTheoryPracticeWorkshopLessonModal.vue";
export default {
  name: "TheoryPracticeWorkshopsLessonsManagement",
  components: {
    ManagementNav,
    BeforeDeleteModal,
    AddTheoryPracticeWorkshopLessonModal,
  },
  async created() {
    await this.$store.dispatch(
      "theoryPracticeWorkshopsLessons/fetchTheoryPracticeWorkshopsLessons",
      { withNotActive: true }
    );
    this.loadImages();
  },
  data: () => ({
    headers: [
      { text: "Aktywna?", value: "active" },
      { text: "Nazwa", value: "name" },
      { text: "Opis", value: "description" },
      { text: "Warsztat", value: "theoryPracticeWorkshop.name" },
      { text: "Zdjęcie", value: "photo" },
      { text: "Akcje", value: "actions", sortable: false },
    ],
    search: "",
    isModalVisible: false,
    lessonData: null,
    currentDate: null,
    isSelectDateModalVisible: false,
    workshopsIdToEdit: "",
    addEmailModalVisible: false,
    isDeleteModalVisible: false,
  }),
  computed: {
    items() {
      return this.$store.getters[
        "theoryPracticeWorkshopsLessons/getTheoryPracticeWorkshopsLessons"
      ];
    },
  },
  methods: {
    confirmDelete(id) {
      this.deletePackage(id);
    },
    closeDeleteModal() {
      this.isDeleteModalVisible = false;
      this.packageData = null;
    },
    showAddEmailModal(id) {
      this.workshopsIdToEdit = id;
      this.addEmailModalVisible = true;
    },
    async loadImages() {
      this.items.forEach(async (item) => {
        this.loadImage(item);
      });
    },

    async loadImage(item) {
      const element = document.getElementById(`image_${item.id}`);
      if (element) {
        if (item.imagePath) {
          const extension = item.imagePath?.split(".")[1];

          element.src = `${SERVER_URL}lessonsImages/${
            item.id
          }.${extension}?d=${new Date().getTime()}`;
        }
      }
    },

    async markStatusAsActiveOrInactive(item) {
      if (!item.active) {
        await this.$store.dispatch(
          "theoryPracticeWorkshopsLessons/markTheoryPracticeWorkshopLessonAsActive",
          { id: item.id }
        );
      } else {
        await this.$store.dispatch(
          "theoryPracticeWorkshopsLessons/markTheoryPracticeWorkshopLessonAsNotActive",
          { id: item.id }
        );
      }
    },

    async refreshWorkshops() {
      await this.$store.dispatch(
        "theoryPracticeWorkshops/fetchTheoryPracticeWorkshopWithNotActive"
      );
      this.loadImages();
    },
    copyWorkshop(data) {
      const { id, ...rest } = data;
      this.lessonData = rest;
      this.lessonData.id = null;
      this.lessonData.copy = true;
      return id;
    },
    htmlToFormattedText(text) {
      const regex =
        /((http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g;
      text = text.replace(regex, '<a href="$1">$1</a>');
      return text;
    },
    editLesson(data) {
      this.lessonData = data;
    },
    async deletePackage(id) {
      await this.$store.dispatch(
        "theoryPracticeWorkshopsLessons/deleteTheoryPracticeWorkshopLesson",
        { id }
      );
    },
    closeModal() {
      this.isModalVisible = false;
      this.lessonData = null;
    },
  },
};
</script>

<style scoped>
.item-image {
  width: 130px;
  height: 130px;
  border-radius: 1rem;
  margin: 1rem;
  object-fit: cover;
}
</style>
